import { render, staticRenderFns } from "./RoomFeaturesBadge.vue?vue&type=template&id=66ac734e&scoped=true"
import script from "./RoomFeaturesBadge.vue?vue&type=script&lang=js"
export * from "./RoomFeaturesBadge.vue?vue&type=script&lang=js"
import style0 from "./RoomFeaturesBadge.vue?vue&type=style&index=0&id=66ac734e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ac734e",
  null
  
)

export default component.exports